/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { AccessKeysContext } from "../context/AccessKeysContext"
import { REQUIRED_MESSAGE } from "./defaultMessages"
import React, { Component } from "react"
import { Col, Form, FormGroup, Row } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"

export default class CheckboxField extends Component {
  validate = (value, accessKeys) => {
    const { name } = this.props
    const ak = accessKeys[name] || {}
    const { required, requiredMessage = REQUIRED_MESSAGE } = { ...this.props, ...ak }
    if (required && value === undefined) {
      return requiredMessage
    }
  }

  render() {
    return (
      <AccessKeysContext.Consumer>
        {(accessKeys = {}) => {
          const { name } = this.props
          const ak = accessKeys[name] || {}
          const {
            hidden,
            placeholder,
            label,
            className,
            xs,
            lg,
            xl,
            md,
            sm,
            xsHidden,
            smHidden,
            mdHidden,
            lgHidden,
            xlHidden,
            disabled,
            hasServerErrors,
            noFormGroup,
            children,
            type = "checkbox"
          } = { ...this.props, ...ak }

          if (hidden) {
            return false
          }

          return (
            <FinalFormField
              name={name}
              component="input"
              type={type}
              placeholder={placeholder}
              className="form-control"
              validate={(value) => {
                return this.validate(value, accessKeys)
              }}
            >
              {({ input, meta }) => {
                const metaError = meta.error && (meta.touched || hasServerErrors)
                const hasError = metaError || meta.submitError
                const cl = {
                  "d-none": xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
                  "d-sm-block": !smHidden,
                  "d-sm-none": smHidden,
                  "d-md-block": !mdHidden,
                  "d-md-none": mdHidden,
                  "d-lg-block": !lgHidden,
                  "d-lg-none": lgHidden,
                  "d-xl-block": !xlHidden,
                  "d-xl-none": xlHidden,
                  "col-no-padding": true
                }
                if (className) {
                  cl[className] = true
                }
                const hasColParam =
                  xs || lg || xl || md || sm || xsHidden || smHidden || mdHidden || lgHidden || xlHidden
                const colParams = { className: cl, xs, lg, xl, md, sm }
                const ElementHtml = label
                let body = [
                  <Row
                    className="optin p-0"
                    noGutters
                    noformgroup={noFormGroup ? "true" : "false"}
                    key={label}
                    {...this.props}
                  >
                    <FinalFormField disabled={disabled} id={name} name={name} component="input" type="checkbox" />
                    <React.Fragment key={label}>
                      {typeof label === "string" ? (
                        <>
                          <Form.Label htmlFor={name}>{label}</Form.Label>
                          {children}
                        </>
                      ) : (
                        <Form.Label htmlFor={name}>
                          <ElementHtml />
                          {children}
                        </Form.Label>
                      )}
                      <React.Fragment key={"alert" + label}>
                        {hasError && <p className="required-message">{meta.error || meta.submitError}</p>}
                      </React.Fragment>
                    </React.Fragment>
                  </Row>
                ]

                if (!noFormGroup) {
                  body = <FormGroup>{body}</FormGroup>
                }

                if (hasColParam) {
                  body = <Col {...colParams}>{body}</Col>
                }

                return body
              }}
            </FinalFormField>
          )
        }}
      </AccessKeysContext.Consumer>
    )
  }
}
